<template>

    <form novalidate class="md-layout" @submit.prevent="validateUser">

      <div class="md-layout-item md-elevation-0"> 
         

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('entidad')">
          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
            Cargos Públicos del {{title}} - Información
          </md-card-header>
          <md-card-content>
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p>             
            <p align="justify">
              Entidad *
            </p>
            <div>            
              <md-field :class="getValidationClass('entidad')">
                <md-input type="text" id="nombreparticipetitular" name="paterno" placeholder="Su respuesta" v-model="form.entidad"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.entidad.required">Esta respuesta es obligatoria.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('cargo')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Cargo *
          </md-card-header>
          <md-card-content>             
            <div>            
              <md-field :class="getValidationClass('cargo')">
                <md-input type="text" id="materno" name="materno" placeholder="Su respuesta" v-model="form.cargo"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.cargo.required">Esta respuesta es obligatoria.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>                     
        
        <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>  

      </div>

    </form>

</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
// import { alpha } from '../variables'
import {
  required,
//   minLength,
//   numeric,
} from 'vuelidate/lib/validators'


export default {
  mixins: [validationMixin],
  name: 'Item8',
  props: ["title", "data"],
  data: () => ({
    form:{
    }
  }),

  mounted: function(){
    this.form = this.$store.state.item.item8
    //this.$store.dispatch("back", false);
  },
  validations(){
    var validate = {
      form: {
        entidad: {required,},
        cargo: {required,},  
      }        
    }
    return validate;
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item8
    },       
    ChangeOption(item){
      if(item != "0"){
        this.form.mancomunosdes = null;
      }
    },
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        var index = "0"
        if(this.data.name == "Participe"){
          index = "9"
        }else{
          index = "10"
        }
        
        this.$emit('setSaveForm', {id:"8", form: this.form, index: index}); 
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    }
     
  },
  computed: {
   
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    }

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
